module.exports = __webpack_public_path__ + "static/media/4.5299d56d.webp";